import { useEffect, useState } from "react"
import { AFSClassification } from "../../helpers/interfaces"
import { FormEditMode } from "../../helpers/constants"
import { createAFSClassification, updateAFSClassification } from "../../apiServices/CTBMappingKeysApi"
import CustomDialog from "../CustomDialog"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"
import { CustomTextField } from "../../layouts/themes"

interface Props {
   
    setFormEditMode: React.Dispatch<React.SetStateAction<number>>
    formEditMode: number
    setAfsClassification: React.Dispatch<React.SetStateAction<AFSClassification[]>>
    afsClassification: AFSClassification[]
    afsToEdit: string
    openAFSForm: boolean
    setOpenAFSForm: React.Dispatch<React.SetStateAction<boolean>>

}
function CreateEditAFS(props: Props) {
    const [afsName, setAFSName] = useState<string>("");
    
    useEffect(() => {
        if (props.formEditMode === FormEditMode.EDIT) {
            var afsName = props.afsClassification.find(e => e.id === props.afsToEdit)
            if (!afsName) return
            setAFSName(afsName.name)
           
        }
    }, [props.afsClassification, props.afsToEdit, props.formEditMode])

    function createNewAFSClassification() {
        createAFSClassification(afsName).then(_afs => {
            props.setOpenAFSForm(false);
            props.setAfsClassification(afs => [...afs, _afs])
            
        })
    }
    function updateNewAFSClassification() {
        updateAFSClassification(props.afsToEdit, afsName).then(result => {
            props.setOpenAFSForm(false);
            props.setAfsClassification(afs => afs.map(a=> a.id === props.afsToEdit ? result: a))
           
        })
    }
    return(
        <>
            <CustomDialog dialogTitle={props.formEditMode === FormEditMode.CREATE ? 'Add New AFS Classification ' : 'Update AFS Classification '} setOpenDialog={props.setOpenAFSForm} openDialog={props.openAFSForm}>
                <form>
                    <div >
                        <label className='title-label'>AFS Classification Name <span className='important'>*</span></label>
                    </div>
                    <div className='col-12'>
                    <div className="form-group mb-0">
                            <div className="">
                            <CustomTextField size="small" id="outlined-basic" placeholder="AFS Classification Name" value={afsName} onChange={(e) => setAFSName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                                
                            </div>
                        </div>
                    </div>
                    <br />
                   

                    <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                        <Button disabled={!afsName} variant="contained" color='secondary' onClick={props.formEditMode === FormEditMode.CREATE ? createNewAFSClassification : updateNewAFSClassification} >
                            <Add />&nbsp; {props.formEditMode === FormEditMode.CREATE ? 'Add AFS Classification' : 'Update AFS Classification'}
                        </Button>
                    </div>
                </form >


            </CustomDialog>

        </>
    )
}
export default CreateEditAFS